module.exports = __webpack_public_path__ + "img/undraw_building_websites_i78t.045e7a09.svg";